export default __webpack_public_path__ + "static/media/mobile_banking.8a8f435e.jpg";